import { render, staticRenderFns } from "./djgrz.vue?vue&type=template&id=0755000b&scoped=true"
import script from "./djgrz.vue?vue&type=script&lang=js"
export * from "./djgrz.vue?vue&type=script&lang=js"
import style0 from "./djgrz.vue?vue&type=style&index=0&id=0755000b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0755000b",
  null
  
)

export default component.exports